import { useState, useEffect } from "react";

export default function Time() {
  const [time, setTime] = useState(getFormattedTime());

  function getFormattedTime() {
    return new Date().toLocaleTimeString("hu-HU", {
      timeZone: "Europe/Budapest",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  }

  useEffect(() => {
    const updateTime = () => setTime(getFormattedTime());

    // Calculate ms until next minute
    const now = new Date();
    const msUntilNextMinute =
      (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    const timeout = setTimeout(() => {
      updateTime();
      const interval = setInterval(updateTime, 60000);
      return () => clearInterval(interval);
    }, msUntilNextMinute);

    return () => clearTimeout(timeout);
  }, []);

  return <div> 🕔{time}</div>;
}
